// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_cg-a";
export var fulfillmentFormRail = "_cg-9";
export var headerTitleRow = "_cg-c";
export var orderDetailsWrapper = "_cg-7";
export var orderLinkTrigger = "_cg-2";
export var paymentInformationGrid = "_cg-h";
export var paymentSummaryColumn = "_cg-i";
export var shipmentContainer = "_cg-b";
export var shipmentDetailsMainPane = "_cg-8";
export var shipmentNavigationCard = "_cg-5";
export var shipmentNavigationRail = "_cg-3";
export var shipmentNavigationRailHeader = "_cg-4";
export var shipmentSummaryFact = "_cg-e";
export var shipmentSummaryGrid = "_cg-d";
export var shipmentSummaryMetadataRow = "_cg-f";
export var shipmentSummaryTags = "_cg-g";
export var shipmentWorkspace = "_cg-0";
export var shipmentWorkspaceContent = "_cg-6";
export var shipmentWorkspaceHeader = "_cg-1";